import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromotion, promotions } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center mb="15px">
          <CFImage src={mobilePromotion} w="100%" alt="Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="35px auto" maxWidth="1300px">
          <CFImage src={promotions} w="90%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
